module.exports = __webpack_public_path__ + "static/media/face_1.2575f748.svg";